module.exports = __webpack_public_path__ + "img/second.c5fd6e7e.png";